import { createClass as _createClass } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "5f876Ww4WRFN7ApkbpmLuBd", "PoolManager", undefined);

import { instantiate, NodePool, isValid } from "cc";
/**
 * 对象池类型
 */

export var E_PoolType;

(function (E_PoolType) {
  E_PoolType["Coin"] = "coin";
  E_PoolType["C_1_0"] = "c_1_0";
  E_PoolType["C_1_1"] = "c_1_1";
  E_PoolType["P_Dove"] = "p_dove";
  E_PoolType["B_Rotate"] = "b_rotate";
  E_PoolType["PS_Dove"] = "ps_doveFly";
  E_PoolType["UI_ColliderTip"] = "ui_colliderTip";
  E_PoolType["MsgTip"] = "msgTip";
  E_PoolType["ShopTip"] = "shopTip";
})(E_PoolType || (E_PoolType = {}));

var PoolManager = /*#__PURE__*/function () {
  function PoolManager() {
    _defineProperty(this, "_pool", new Map());

    _defineProperty(this, "_prefab", new Map());
  }

  var _proto = PoolManager.prototype;

  _proto.clearAll = function clearAll() {
    this._pool.forEach(function (curPool) {
      curPool.clear();
    });
  }
  /**
   * 添加pool
   * @param aimPfb prefab
   * @param initNum 实例化数量
   * @param comName 脚本名字
   */
  ;

  _proto.addPool = function addPool(aimPfb, initNum, comName) {
    if (comName === void 0) {
      comName = "";
    }

    this._prefab.set(aimPfb.data.name, aimPfb);

    var tNodePool = new NodePool(comName ? comName : aimPfb.data.name);

    this._pool.set(aimPfb.data.name, tNodePool);

    for (var i = 0; i < initNum; i++) {
      var newNode = instantiate(aimPfb);
      tNodePool.put(newNode);
    }
  };

  _proto.initPool = function initPool(aimPfb, initNum, comName) {
    if (comName === void 0) {
      comName = "";
    }

    this._prefab.set(aimPfb.data.name, aimPfb);

    var tNodePool = new NodePool(comName ? comName : aimPfb.data.name);

    this._pool.set(aimPfb.data.name, tNodePool);

    for (var i = 0; i < initNum; i++) {
      var newNode = instantiate(aimPfb);
      tNodePool.put(newNode);
    }
  };

  _proto.getItem = function getItem(name, isInit) {
    if (isInit === void 0) {
      isInit = false;
    }

    var curPool = this._pool.get(name);

    if (curPool && curPool.size() > 0) {
      return curPool.get();
    } else if (this._prefab.get(name)) {
      return instantiate(this._prefab.get(name));
    } else {
      return null;
    }
  };

  _proto.returnItem = function returnItem(item) {
    if (item && isValid(item, true)) {
      var curPool = this._pool.get(item.name);

      if (curPool) {
        curPool.put(item);
      } else {
        item.destroy();
      }
    } else {
      if (item) {
        item.destroy();
      }
    }
  };

  _createClass(PoolManager, null, [{
    key: "I",
    get: function get() {
      if (!PoolManager._I) {
        PoolManager._I = new PoolManager();
      }

      return PoolManager._I;
    }
  }]);

  return PoolManager;
}();

_defineProperty(PoolManager, "_I", null);

export { PoolManager as default };

_cclegacy._RF.pop();